import * as React from 'react';
const LogOutIcon = (props) => (
  <svg fill="none" viewBox="0 0 16 16" {...props}>
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      clipPath="url(#clip0_4421_20225)"
    >
      <path d="M5.5 8h10M11.5 4l4 4-4 4M8.5 15.5H2A1.5 1.5 0 0 1 .5 14V2A1.5 1.5 0 0 1 2 .5h6.5" />
    </g>
    <defs>
      <clipPath id="clip0_4421_20225">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default LogOutIcon;